import "./TeamAndContact.module.css";
import Header from "@/reusable_sections/Header";
import MeetTheTeam from "./sections/MeetTheTeam";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function TeamAndContactPage() {
  return <div>
      <Header />
      <MeetTheTeam />
      <ContactUs />
      <Footer />
    </div>;
}